const mockLoginParams = {
  userName: 'bud@snirgel.de',
  password: 'test',
};

export { mockLoginParams };
